import Link from "next/link";
import { ChevronDoubleDownIcon } from "@heroicons/react/outline";


export default function Hero({ topTitle, title, subtitle }) {
  return (
    <section className="relative bg-transparent bg-center overflow-hidden font-['Inter']">
      <div className="bg-transparent" tabIndex={0}>
 <div className="relative pt-24 lg:pt-44 lg:pb-16">
          <div className="container px-4 mx-auto">
            <div className="relative flex flex-col justify-center items-center -mx-4">
              <div className="w-full max-w-3xl px-4 mb-12 md:mb-0 text-center flex flex-col items-center">
                <h1 className="mb-6 hero-top-title">
                  {topTitle}
                  <br />
                </h1>
                <div className="main-top-title mb-8">
                  {title}
                </div>
                <p className="mb-8 body-text max-w-2xl px-8 md:px-0">
                  {subtitle}
                </p>
                <div className="flex flex-col lg:flex-row justify-center gap-4">
                  <Link
                    href="/contact"
                    className="btn-primary"
                  >
                    Contact us
                  </Link>
                  <Link
                    href="/solutions#offerings"
                    className="btn-secondary"
                  >
                    See other offerings
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <ChevronDoubleDownIcon className="absolute right-8 lg:right-12 animate-shortfade opacity-0 text-maingray h-8 lg:h-12 z-50 bottom-2" />
        </div>
      </div>
    </section>
  );
}